export const STATUS = {

	SOLICITADA : 1,
    SELF_EVALUATION : 2,
    BOSS_EVALUATION : 3,
    ACTION_PLAN : 4,
    COMPLETED : 5,
	
}
export const STATUS_PLAN_ACTION = {

	    CREADO : 1,
    IN_PROGRESS : 2,
    COMPLETED : 3,
}

